import { apiCall } from "./service";
import { URL_PROJECT_PURCHASE_ORDERS, URL_PURCHASE_ORDERS } from "./URL";

export const api = {

  sortPurchaseOrdersRequest(params) {
    return apiCall.pagination({
      url: `${URL_PROJECT_PURCHASE_ORDERS(params.id)}?pageNumber=${params.page}&pageSize=${params.size}&orderBy=${params.orderBy}`,
      isAuthToken: true
    });
  },

  getPurchaseOrdersRequest(params) {
    const { parent, search, id, page, size } = params;
    const paginationParams = { pageNumber: page, pageSize: size };
    let url = URL_PROJECT_PURCHASE_ORDERS(params.id);

    if (search) {
      paginationParams.searchTerm = search;
    }

    const queryParams = new URLSearchParams(paginationParams).toString();
    const fullUrl = `${url}?${queryParams}`;

    return apiCall.pagination({ url: fullUrl });
  },

  fetchSinglePurchaseOrderRequest(id) {
    return apiCall.get({ url: `${URL_PURCHASE_ORDERS}${id}` });
  },

  getPurchaseOrderRequest(params) {
    return apiCall.get({ url: `${URL_PURCHASE_ORDERS}${params.id}`, isAuthToken: true, params });
  },

  createPurchaseOrderRequest(params) {
    return apiCall.post({ url: `${URL_PURCHASE_ORDERS}`, isAuthToken: true, params: params.payload });
  },

  updatePurchaseOrderRequest(params) {
    return apiCall.put({ url: `${URL_PURCHASE_ORDERS}${params.id}`, isAuthToken: true, params: params.payload });
  },

  deletePurchaseOrderRequest(params) {
    return apiCall.delete({ url: `${URL_PURCHASE_ORDERS}${params.id}`, isAuthToken: true, params });
  },

  updatePurchaseOrderFlagRequest(params) {
    return apiCall.patch({ url: `${URL_PURCHASE_ORDERS}${params.id}`, isAuthToken: true, params: params.payload });
  }

};

export default api;
